import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const DossierIncompleteRenderer = (props) => {
	if ((props.data.incomplete != null && props.data.incomplete) || (props.data.dossier != null && props.data.dossier.incomplete)) {
		return <span title={"Dossier incomplet"} style={{ marginLeft: '3px', paddingTop: '3px' }}>
			<FontAwesomeIcon icon={faExclamationTriangle} style={{ color: '#ea0000', height: '20px', marginRight: '10px',marginTop: '10px' }} />
		</span>
	}

	return '';
};

export default DossierIncompleteRenderer;
